import { Button, Space, Typography } from "antd";
import { NavigateFunction } from "react-router-dom";

import {
    RVGridActionableCell,
    RVTimeDisplay,
    getFilterValue,
    getSortOrder,
    OperatorType,
    QueryParams,
    RVGRID_COLUMN_SIZE_OPTIONS,
} from "@regal-voice/ui";
import { GridColumnsType } from "Types/ComponentTypes/RVGridTypes";
import { EventDefinition } from "Types/EventDefinition";

import styles from "./GridColumns.module.scss";

export function getColumns(
    navigate: NavigateFunction,
    queryParams: Partial<QueryParams>
): GridColumnsType<EventDefinition> {
    const columnsData: GridColumnsType<EventDefinition> = [
        {
            size: RVGRID_COLUMN_SIZE_OPTIONS.MEDIUM,
            dataIndex: "eventName",
            key: "eventName",
            title: "Event Name",
            sorter: true,
            sortOrder: getSortOrder(queryParams, "eventName", null),
            render(_: any, record: EventDefinition): JSX.Element {
                return (
                    <RVGridActionableCell
                        key={`${record.eventType}-${record.eventName}`}
                        content={record.eventName}
                        linkTo={`${encodeURIComponent(record.eventType)}/${encodeURIComponent(record.eventName)}`}
                    />
                );
            },
        },
        {
            size: RVGRID_COLUMN_SIZE_OPTIONS.SMALL,
            dataIndex: "showInFeed",
            key: "showInFeed",
            title: "Activity Feed",
            filters: [
                {
                    text: "Yes",
                    value: "true",
                },
                {
                    text: "No",
                    value: "false",
                },
            ],
            filteredValue: getFilterValue(queryParams, "showInFeed"),
            filterMultiple: true,
            filterOperator: OperatorType.IN,
            defaultFilteredValue: ["true", "false"],
            filterResetToDefaultFilteredValue: true,
            // eslint-disable-next-line react/display-name
            render: (showInFeed: boolean) => {
                return <>{showInFeed ? "Yes" : "No"}</>;
            },
        },
        {
            size: RVGRID_COLUMN_SIZE_OPTIONS.SMALL,
            dataIndex: "updatedBy",
            key: "updatedBy",
            title: "Updated",
            // eslint-disable-next-line react/display-name
            render: (_: any, record: EventDefinition) => {
                return record.updatedAt && record.updatedBy ? (
                    <div className={styles.col} key={`${record.eventType}-${record.eventName}`}>
                        {!!record.updatedAt && <RVTimeDisplay time={record.updatedAt} />}
                        {!!record.updatedBy && (
                            <Typography.Text className={styles.userName}>{record.updatedBy}</Typography.Text>
                        )}
                    </div>
                ) : (
                    <div>-</div>
                );
            },
        },
        {
            size: RVGRID_COLUMN_SIZE_OPTIONS.XSMALL,
            key: "actions",
            dataIndex: "actions",
            title: "Actions",
            render(_: any, record: EventDefinition) {
                return (
                    <Space size={16} wrap align="baseline" key={`${record.eventType}-${record.eventName}`}>
                        <Button
                            onClick={() =>
                                navigate(
                                    `${encodeURIComponent(record.eventType)}/${encodeURIComponent(record.eventName)}`
                                )
                            }
                        >
                            Edit
                        </Button>
                    </Space>
                );
            },
        },
    ];
    return columnsData;
}
